import React, { useEffect, useState } from "react";
import { BsChatDots } from "react-icons/bs";
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";
import { FaStar } from "react-icons/fa";
import { HiOutlineChatBubbleBottomCenterText } from "react-icons/hi2";
import { useSnackbar } from "../../../../component/SnackbarContext";
import axiosInstance from "../../../../configuration/request";
import CustomPopupForm from "../../../../component/customPopupModel";
import ChatWithStore from "./chatWithStore";
const DIALOG_TYPES = {
  CREATE: "review",
};
export default function OrderSummary({
  orderDetail,
  onReviewSubmit,
  shouldAutoOpenStoreChat = false,
  onAutoOpenStoreChatHandled,
}) {
  const [shopShowChat, setShopShowChat] = useState(false);
  const hasFeedback =
    orderDetail?.customer_feedback_store?.score &&
    orderDetail?.customer_feedback_store?.content;
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [mode, setMode] = useState("create");
  const showSnackbar = useSnackbar();

  useEffect(() => {
    if (shouldAutoOpenStoreChat && orderDetail?.order_id) {
      setShopShowChat(true);
      onAutoOpenStoreChatHandled?.();
    }
  }, [onAutoOpenStoreChatHandled, orderDetail?.order_id, shouldAutoOpenStoreChat]);
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDialogType("");
  };

  const handleAddReview = () => {
    setMode("create");
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleSubmit = (ratings) => {
    const payload = {
      score: ratings.rating,
      content: ratings.feedback,
      order_id: orderDetail?.order_id,
      maskedName: true,
      inAppropriate :false
    };
    axiosInstance
      .post(`/customer/store/feedback/create/${orderDetail?.storeId}`, payload)
      .then(() => {
        handleCloseDialog();
        onReviewSubmit();
      })
       .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      });
  };

  return (
    <div className="bg-white border border-[#D8DAE5] rounded-xl p-4 w-full flex flex-col items-start xlg:flex-row  xlg:items-center justify-between gap-6">
      {/* LEFT: Image + Store Info */}
      <div className="flex items-start w-full md:w-auto">
        <img
          src={orderDetail?.image}
          alt="Laundry"
          className="w-36 h-24 object-cover rounded-xl flex-shrink-0"
        />
        <div className="ml-4 flex flex-col justify-between h-full">
          <div
            className="text-base font-[400] text-[#606060] truncate max-w-[200px]"
            title={orderDetail?.order_code}
          >
            {orderDetail?.order_code}
          </div>
          <div className="text-sm font-[400] text-[#606060]">Laundry Name</div>
          <div className="text-base font-bold text-[#063853] mt-1">
            {orderDetail?.storeName}
          </div>

          {/* Store rating stars */}
          <div className="flex mt-2">
            {[1, 2, 3, 4, 5].map((star) => (
              <FaStar
                key={star}
                size={14}
                className={
                  star <= orderDetail?.storeRating
                    ? "text-[#FACC15]"
                    : "text-gray-300"
                }
              />
            ))}
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="hidden xlg:block h-28 border border-dotted border-[#D2D2D2]" />
      <div className="block xlg:hidden border-t border-dotted my-3 border-[#D2D2D2] w-full" />

      {/* MIDDLE: Store Rating + Buttons */}
      <div className="flex flex-col w-full md:w-auto">
        <div className="text-base text-[#606060] font-[500] mb-1">
          Store Rating
        </div>

        {/* Review Stars (clickable) */}
          <div className="flex text-xl mb-3">
            {[1, 2, 3, 4, 5].map((star) => (
              <FaStar
                key={star}
                size={20}
                className={
                  star <= orderDetail?.customer_feedback_store?.score
                    ? "text-[#FACC15]"
                    : "text-gray-300"
                }
              />
            ))}
          </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-2">
          <CustomButton
            onClick={handleAddReview}
            customeClass="customer-outline-button h-[35px] w-[150px] text-sm"
          >
            <HiOutlineChatBubbleBottomCenterText className="mr-2 text-lg" />
            {hasFeedback ? "View Review" : "Write Review"}
          </CustomButton>
          <CustomButton
            onClick={() => setShopShowChat(true)}
            customeClass="customer-dark-button h-[35px] w-[150px] text-sm"
          >
            <BsChatDots className="text-lg font-bold mr-1" />
            Chat with Store
          </CustomButton>
        </div>
      </div>

      {dialogType === DIALOG_TYPES.CREATE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.CREATE}
          mode={mode}
          dialogDetails={orderDetail?.customer_feedback_store}
          onSubmit={handleSubmit}
        />
      )}
      {shopShowChat && (
        <div className="fixed bottom-4 right-4 w-[90%] max-w-sm z-50">
          <ChatWithStore
            onClose={() => setShopShowChat(false)}
            order_id={orderDetail?.order_id}
          />
        </div>
      )}
    </div>
  );
}
